
import {
    anime_outer_space_but_red,
    digital_painting_3_black_cars,
    digital_painting_blue_rose,
    digital_painting_butterfiles,
    digital_painting_yeat,
    fantasy_anime,
    sky_inside_a_space_ship_looking_at_the_earth,
    tech_noir__cyberpunk_money,
    realistic_sky_color_red_and_orange_water_fall,
    cover1,
    cover2,
    cover3,
    cover4,
    cover5,
    cover6
} from "../images/"
import { Link } from "react-router-dom";

const Home = () => {
    const galleryData = [
        {
            title: "Trey",
            playlist: "https://www.youtube.com/embed/videoseries?list=PLaqPzNpBaE7wz0jO0vby92RCpGetnkS5R",
            imageUrl: cover4,
            bg1: realistic_sky_color_red_and_orange_water_fall,
            bg2: sky_inside_a_space_ship_looking_at_the_earth
        },
        {
            title: "DJ",
            playlist: "https://www.youtube.com/embed/videoseries?list=PL6XR7PN1fG6b4ksQqtGpmJQsX2YXpWWoy",
            imageUrl: cover5,
            bg1: anime_outer_space_but_red,
            bg2: sky_inside_a_space_ship_looking_at_the_earth
        },
        {
            title: "Nyla",
            playlist: "https://www.youtube.com/embed/videoseries?list=PLSKR5ii__Lmkn4dtiOoAmhOTPp-yNmpR5",
            imageUrl: cover3,
            bg1: digital_painting_blue_rose,
            bg2: sky_inside_a_space_ship_looking_at_the_earth
        },
        {
            title: "Nymair",
            playlist: "https://youtube.com/playlist?list=PLxxgX6fw9TIeqEdWQfW-PsPlPwguUFTmV",
            coverImage: "",
            imageUrl: digital_painting_3_black_cars,
            bg2: sky_inside_a_space_ship_looking_at_the_earth
        },
        {
            title: "Makhia",
            playlist: "https://www.youtube.com/embed/videoseries?list=PL6XR7PN1fG6b4ksQqtGpmJQsX2YXpWWoy",
            imageUrl: cover1,
            imageUrlbg1: fantasy_anime,
            bg2: sky_inside_a_space_ship_looking_at_the_earth
        },
        {
            title: "Miracle",
            playlist: "https://www.youtube.com/embed/videoseries?list=PLonAHCx3bOdH5Ay7qOLJxzr0x937CHVLL",
            imageUrl: cover2,
            bg1: digital_painting_butterfiles,
            bg2: sky_inside_a_space_ship_looking_at_the_earth
        },
        {
            title: "Yolanda",
            playlist: "https://www.youtube.com/embed/videoseries?list=PL6XR7PN1fG6b4ksQqtGpmJQsX2YXpWWoy",
            coverImage: "",
            imageUrl: digital_painting_yeat,
            bg2: sky_inside_a_space_ship_looking_at_the_earth
        },
        {
            title: "Wyniquekia",
            playlist: "https://www.youtube.com/embed/videoseries?list=PLeNh5MeydHs0OjrctVguPPkDllNBlKbkI",
            coverImage: "",
            imageUrl: tech_noir__cyberpunk_money,
            bg2: sky_inside_a_space_ship_looking_at_the_earth
        }
        ,{
            title: "Marcine",
            playlist: "https://youtube.com/playlist?list=PLjeBqM2aVadpmdL5tkvgsbAnklXwjMoMC",
            imageUrl: cover6,
        }
    ];

  return (
    <>
      <h1 className="mt-40 ml-44 text-4xl font-extrabold">Class Projects</h1>

      <div className="grid grid-cols-3 gap-4 mt-8 ml-10">
        {galleryData.map((item, index) => (
            <Link key={index} to={`/${item.title}`}>
          <div className="flex flex-col items-center">
            <img src={item.imageUrl} alt={item.title} className="max-w-xs max-h-40" />
            <p className="text-sm mt-2">{item.title}</p>
          </div>
          </Link>
        ))}
      </div>
    </>
  );

}

export default Home;